import type { ProductItemThemeSettings } from '@providers/ThemeProvider/types';

export type ProductRatingPropsMapSettings = boolean;

export const useConnectProductRating = (
  settings: ProductItemThemeSettings,
  place: 'img' | 'info'
) => {
  const productElmSettings =
    place === 'img' ? settings.productImg.elements : settings.productInfo?.elements;

  return {
    props: !!productElmSettings?.rating,
  };
};
